export default {
  metadata: {
    version: '1.0.0',
    id: 'date-picker-desktop-1.0.0',
    name: 'JDSDatepickerDesktop',
    platform: 'web'
  },
  hierarchy: {
    popup: [
      {
        'popup-container': ['jds_datepicker_desktop_internal']
      }
    ]
  },
  base: {
    popup: {
      priority: 70,
      passive: true
    },
    'popup-container': {
      hidden: true,
      'flex-direction': '{d_0}',
      'justify-content': '{d_1}',
      'align-items': '{d_2}',
      opacity: '{opacity.invisible}',
      transition: {
        property: ['opacity'],
        duration: '{medium}',
        'timing-function': '{easeExit}'
      }
    }
  },
  variant: {
    open: {
      true: {
        popup: {
          passive: false
        },
        'popup-container': {
          hidden: false,
          opacity: '{opacity.enabled}',
          transition: {
            'timing-function': '{easeEntrance}'
          }
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      state: {
        values: ['default', 'month_view', 'year_view']
      },
      open: {
        values: [false, true]
      }
    },
    data: {
      'popup-container': {
        'padding-left': {
          type: 'size',
          name: 'offsetX'
        },
        'padding-top': {
          type: 'size',
          name: 'offsetY'
        }
      },
      jds_datepicker_desktop_internal: {
        triggerRef: {
          type: 'ref',
          name: 'triggerRef'
        },
        monthName: {
          type: 'string',
          name: 'monthName'
        },
        year: {
          type: 'number',
          name: 'year'
        },
        yearSelectable: {
          type: 'boolean',
          name: 'yearSelectable'
        },
        monthSelectable: {
          type: 'boolean',
          name: 'monthSelectable'
        },
        months: {
          type: 'list',
          name: 'months',
          object: {
            name: 'string',
            selected: 'boolean',
            disabled: 'boolean'
          }
        },
        current: {
          type: 'number',
          name: 'year'
        },
        yearData: {
          type: 'object',
          name: 'yearData',
          object: {
            count: 'number',
            disabled: 'list',
            min: 'number',
            max: 'number'
          }
        },
        loadedYears: {
          type: 'list',
          name: 'loadedYears',
          object: {
            name: 'string',
            selected: 'boolean',
            disabled: 'boolean'
          }
        },
        date: {
          type: 'number',
          name: 'date'
        },
        month: {
          type: 'number',
          name: 'month'
        },
        value: {
          type: 'date',
          name: 'value'
        },
        calendarData: {
          type: 'object',
          name: 'calendarData',
          object: {
            disabledDays: 'list',
            disabledDates: 'list',
            max: 'date',
            min: 'date'
          }
        },
        yearLoadCount: {
          type: 'number',
          platform: 'web',
          name: 'yearLoadCount'
        },
        days: {
          type: 'JDSDatepickerCalendarHeader.days',
          name: 'days',
          object: {
            letter: 'string'
          }
        },
        row: {
          type: 'list',
          name: 'rows.row',
          object: {
            value: 'string',
            state: 'JDSDatepickerCalendarButton.state'
          }
        }
      }
    },
    events: {
      popup: {
        onClick: 'onClose'
      },
      jds_datepicker_desktop_internal: {
        onClose: 'onClose',
        onSelect: 'onSelect'
      }
    },
    a11y: {
      jds_datepicker_desktop_internal: {
        properties: {
          previousButtonAriaLabel: 'previousButtonAriaLabel',
          closeAriaLabel: 'closeAriaLabel',
          previousMonthAriaLabel: 'previousMonthAriaLabel',
          nextMonthAriaLabel: 'nextMonthAriaLabel'
        }
      }
    }
  }
};
